import { apiHost } from '@libs/providers/api-host.provider';

export async function fetchTranslations(locale: string) {
  const url = `${apiHost()}/public/gofinans-website/translations/${locale}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error('Failed to fetch translations');
  }
  return res.json();
}
